import axios from '@/axios'
const http = {
  getBlockNames (params) {
    return axios.get('/pcs-portal/portal-external-management/getBlockNames', {
      params
    })
  },
  acquireFirstPortalTitleList (params) {
    return axios.get('/pcs-portal/portal-external-management/acquireFirstPortalTitleList', {
      params
    })
  },
  acquireFirstPortalConsultTitleList (params) {
    return axios.get('/pcs-portal/portal-external-management/acquireFirstPortalConsultTitleList', {
      params
    })
  },
  acquireContentByBlockId (params) {
    return axios.get('/pcs-portal/portal-external-management/acquireContentByBlockId', {
      params
    })
  },
  acquireWholeContentByContentId (params) {
    return axios.get('/pcs-portal/portal-external-management/acquireWholeContentByContentId', {
      params
    })
  },
  getOrglist () {
    return axios.post('pcs-exam/getOrglist')
  },
  sendMessage (params) {
    return axios.post('/pcs-exam/sendMessage', params)
  },
  getPublicQuestions2 (params) {
    return axios.get('/pcs-consult/getPublicQuestions2', {
      params
    })
  },
  getAppointQuestions (params) {
    return axios.get('/pcs-consult/getAppointQuestions', {
      params
    })
  },
  getAnswers (params) {
    return axios.get('/pcs-consult/getAnswers', {
      params
    })
  },
  getReplies (params) {
    return axios.get('/pcs-consult/getReplies', {
      params
    })
  },
  addReply (params) {
    return axios.put('/pcs-consult/addReply', params)
  },
  getCounselorInfo () {
    return axios.get('/pcs-consult/getCounselorInfo', {
      headers: {
        Authorization: 'bearer ' + window.localStorage.getItem('access_token')
      }
    })
  },
  addAnswer (data) {
    return axios.get(`pcs-consult/addAnswer?content=${data.content}&questionId=${data.questionId}&responderId=${data.responderId}&responderType=咨询师`)
  },
  getOrgRegionInfo () {
    return axios.get('/pcs-exam/getOrgRegionInfo')
  },
  // 根据城市获取机构列表
  getOrgInfoByCity (params) {
    return axios.post('/pcs-exam/getOrgInfoByCity', {
      ...params
    })
  },
  // 获取学校列表
  getShoolList () {
    return axios.post('pcs-exam/getOrglist')
  }
}
export default http
